var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#D9D9D9",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 23.8333H13.3542L21.5 15.6875L20.3125 14.5L12.1667 22.6458V23.8333ZM11.3333 25.5C11.0972 25.5 10.8993 25.4201 10.7396 25.2604C10.5799 25.1007 10.5 24.9028 10.5 24.6667V22.6458C10.5 22.4236 10.5417 22.2118 10.625 22.0104C10.7083 21.809 10.8264 21.6319 10.9792 21.4792L21.5 10.9792C21.6667 10.8264 21.8507 10.7083 22.0521 10.625C22.2535 10.5417 22.4653 10.5 22.6875 10.5C22.9097 10.5 23.125 10.5417 23.3333 10.625C23.5417 10.7083 23.7222 10.8333 23.875 11L25.0208 12.1667C25.1875 12.3194 25.309 12.5 25.3854 12.7083C25.4618 12.9167 25.5 13.125 25.5 13.3333C25.5 13.5556 25.4618 13.7674 25.3854 13.9688C25.309 14.1701 25.1875 14.3542 25.0208 14.5208L14.5208 25.0208C14.3681 25.1736 14.191 25.2917 13.9896 25.375C13.7882 25.4583 13.5764 25.5 13.3542 25.5H11.3333ZM20.8958 15.1042L20.3125 14.5L21.5 15.6875L20.8958 15.1042Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.f94253ec679b76f9c04b34feccdaa04d.svg";
export { ForwardRef as ReactComponent };